import { OnInit, ElementRef, } from "@angular/core";
import { resolveThemeCssClass } from "../lib/helper/panel-settings";
import { applyRteSettings } from '../../shared/utils/rte-style-settings-utils';
import { applyTitleSettings } from '../../shared/utils/title-style-settings-utils';
var isReversedEnum;
(function (isReversedEnum) {
    isReversedEnum["Has"] = "Title - Image - Text";
    isReversedEnum["No"] = "Title - Text - Image";
})(isReversedEnum || (isReversedEnum = {}));
var InfoCardPanelComponent = /** @class */ (function () {
    function InfoCardPanelComponent(hostRef) {
        this.hostRef = hostRef;
        this.isReversed = false;
    }
    Object.defineProperty(InfoCardPanelComponent.prototype, "hostClasses", {
        get: function () {
            return resolveThemeCssClass(this.data.panelSettings);
        },
        enumerable: true,
        configurable: true
    });
    InfoCardPanelComponent.prototype.ngOnInit = function () {
        if (this.data) {
            this.isReversed = isReversedEnum.Has === this.data.ordering.value;
            this.prepareMedia();
        }
    };
    InfoCardPanelComponent.prototype.ngAfterViewInit = function () {
        this.setCustomThemeProperties(this.data);
    };
    InfoCardPanelComponent.prototype.setCustomThemeProperties = function (d) {
        applyRteSettings(this.data, this.descriptionEl);
        applyTitleSettings(this.data, this.titleEl);
        if (d.backgroundColor && d.backgroundColor.value) {
            this.hostRef.nativeElement.style.setProperty("--info-background-color", d.backgroundColor.value);
        }
        if (this.panelElRef &&
            this.panelElRef.nativeElement &&
            this.data &&
            this.data.backgroundImage &&
            this.data.backgroundImage.value) {
            this.panelElRef.nativeElement.style.backgroundImage =
                "url(" + this.data.backgroundImage.value.src + ")";
            this.panelElRef.nativeElement.style.backgroundSize = "cover";
            this.panelElRef.nativeElement.style.backgroundRepeat = "no-repeat";
        }
    };
    InfoCardPanelComponent.prototype.prepareMedia = function () {
        try {
            if (!this.data || !this.data.media || !this.data.media.value)
                return;
            var media = this.data.media.value;
            this.hasImage = !!media.image;
            if (this.hasImage) {
                this.media = media.image;
            }
            else {
                this.media = {
                    desktop: media.video.desktop || media.video.mobile,
                    mobile: media.video.mobile || media.video.desktop,
                };
            }
        }
        catch (err) {
            console.error("TODO: fix it please");
        }
    };
    return InfoCardPanelComponent;
}());
export { InfoCardPanelComponent };
